// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/checkbox/Primary.story.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Checkbox } from '@sail/ui';
export const Primary = () => {
  return <Checkbox label="This is a Checkbox." onChange={e => {
    // eslint-disable-next-line no-console
    console.log(e.target.checked);
  }} />;
};